import type { Tool } from './types';

export const mangalDoshaCalculator: Tool = {
  slug: 'mangal-dosha-calculator',
  metaTitle: 'Mangal Dosha Calculator — Free Manglik Check by Date of Birth',
  metaDescription:
    'Free Mangal Dosha (Manglik) calculator. Check instantly whether you are Manglik by date of birth, see the severity, whether it cancels, and AI-explained remedies.',
  keywords:
    'mangal dosha calculator, manglik calculator, manglik dosha, kuja dosha, mangal dosha check, am i manglik, mangal dosha remedies',
  eyebrow: 'Manglik Check',
  h1: 'Mangal Dosha Calculator (Manglik Check)',
  appName: 'KundaliAI Mangal Dosha Calculator',
  calculator: 'mangal-dosha',
  intro:
    'Find out instantly whether you are Manglik. KundaliAI checks Mars against your Lagna, Moon and Venus, tells you the severity of the Mangal Dosha, whether recognized cancellations apply, and explains the remedies — all in plain language, free to start.',
  ctaLabel: 'Check my Mangal Dosha free',
  ctaHref: '/chat',
  sections: [
    {
      heading: 'What is Mangal Dosha?',
      body: 'Mangal Dosha — also called Manglik Dosha or Kuja Dosha — occurs when Mars (Mangal) sits in certain houses of the birth chart. Traditionally, if Mars falls in the **1st, 2nd, 4th, 7th, 8th or 12th house** measured from the Lagna (ascendant), the Moon, or Venus, the chart is considered Manglik. It is most often discussed in the context of marriage compatibility.',
    },
    {
      heading: 'How the calculator works',
      body: "KundaliAI computes Mars's exact placement from your birth details and checks it from all three reference points — **Lagna, Moon and Venus** — the way a careful Jyotishi would. It then classifies the dosha (from mild to strong), and, crucially, checks the **cancellation (Manglik Dosha Bhanga)** conditions, because many charts labelled Manglik by a simple tool are actually cancelled once those rules are applied.",
    },
    {
      heading: 'Cancellations and remedies',
      body: 'Mangal Dosha is often over-stated. It can be reduced or cancelled by factors such as Mars in its own or exalted sign, benefic aspects, both partners being Manglik, or specific house placements. KundaliAI explains whether any of these apply to you, and if remedies are advised, describes the traditional ones — you can ask follow-up questions about your specific chart.',
    },
  ],
  faq: [
    {
      question: 'How do I know if I am Manglik?',
      answer:
        'You are considered Manglik if Mars occupies the 1st, 2nd, 4th, 7th, 8th or 12th house from your Lagna, Moon or Venus. Enter your date, time and place of birth and the calculator checks all three references for you.',
    },
    {
      question: 'Does Mangal Dosha always affect marriage?',
      answer:
        'No. Many Manglik charts have recognized cancellation conditions, and the dosha varies in strength. KundaliAI checks for these cancellations rather than giving a blunt yes/no.',
    },
    {
      question: 'Can two Manglik people marry?',
      answer:
        'In traditional Vedic astrology, when both partners are Manglik the dosha is often considered mutually cancelled. The calculator flags this and you can ask the AI astrologer about your specific case.',
    },
    {
      question: 'What are the remedies for Mangal Dosha?',
      answer:
        'Remedies range from specific pujas and mantras to timing considerations for marriage. KundaliAI describes the traditional remedies relevant to the severity found in your chart.',
    },
  ],
  related: [
    { label: 'Kundli matching by AI', href: '/kundli-matching' },
    { label: 'Free Kundli by date of birth', href: '/free-kundli' },
    { label: 'Talk to an AI astrologer', href: '/ai-astrologer' },
  ],
};
